import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

type Language = "en" | "ar";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "ar",
    fallbackLng: "ar",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

const isRTL = (language: Language): boolean => ["ar"].includes(language);

const savedLanguage = localStorage.getItem("i18nextLng") as Language | null;

if (savedLanguage) {
  i18n.changeLanguage(savedLanguage);
}

i18n.on("languageChanged", (lang: Language) => {
  localStorage.setItem("i18nextLng", lang);
  document.documentElement.setAttribute("dir", isRTL(lang) ? "rtl" : "ltr");
});

if (isRTL(i18n.language as Language)) {
  document.documentElement.setAttribute("dir", "rtl");
} else {
  document.documentElement.setAttribute("dir", "ltr");
}

export default i18n;
